import { Box } from "@mui/material";
import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { InitiatePaymentDetail } from "Components/Merchant/InitiatePaymentDetail/InitiatePaymentDetail";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { useIsMobile } from "Hooks/useIsMobile";
import { useNavigate } from "Navigation/useNavigate";
import { Resources, useResource } from "Translations/Resources";
import { appUrl } from "Utils/UrlUtils";
import { useParams } from "react-router";

export const MerchantInitiatePaymentDetailPage = () => {
  const { t } = useResource();
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const { id } = useParams<{ id: string }>();

  // This should not happen, but just in case
  if (!id) {
    navigate(appUrl("initiate-form-payment"));

    return null;
  }

  return (
    <Box p={isMobile ? 3 : 0}>
      <AuthenticatedLayout
        title={t(Resources.Pages.Titles.MerchantAcceptPayment)}
        backNavigation={{
          mode: "staticUrl",
          url: appUrl("dashboard"),
        }}
        isBottomMenuHidden={isMobile}
        isTitleSmall={isMobile}
        isPaddingDisabled={isMobile}
      >
        <StyledPageWrapper>
          <div className="left-content">
            <InitiatePaymentDetail transactionPublicID={id} />
          </div>
        </StyledPageWrapper>
      </AuthenticatedLayout>
    </Box>
  );
};

export default MerchantInitiatePaymentDetailPage;
